export const COUNTRY_LIST = [
  { code: 'AF', region: 'Asia', country: 'Afghanistan' },
  { code: 'AL', region: 'Europe', country: 'Albania' },
  { code: 'DZ', region: 'Africa', country: 'Algeria' },
  { code: 'AD', region: 'Europe', country: 'Andorra' },
  { code: 'AO', region: 'Africa', country: 'Angola' },
  { code: 'AG', region: 'Latin America and the Caribbean', country: 'Antigua and Barbuda' },
  { code: 'AR', region: 'Latin America and the Caribbean', country: 'Argentina' },
  { code: 'AM', region: 'Asia', country: 'Armenia' },
  { code: 'AU', region: 'Oceania', country: 'Australia' },
  { code: 'AT', region: 'Europe', country: 'Austria' },
  { code: 'AZ', region: 'Asia', country: 'Azerbaijan' },
  { code: 'BS', region: 'Latin America and the Caribbean', country: 'Bahamas' },
  { code: 'BH', region: 'Asia', country: 'Bahrain' },
  { code: 'BD', region: 'Asia', country: 'Bangladesh' },
  { code: 'BB', region: 'Latin America and the Caribbean', country: 'Barbados' },
  { code: 'BY', region: 'Europe', country: 'Belarus' },
  { code: 'BE', region: 'Europe', country: 'Belgium' },
  { code: 'BZ', region: 'Latin America and the Caribbean', country: 'Belize' },
  { code: 'BJ', region: 'Africa', country: 'Benin' },
  { code: 'BM', region: 'North America', country: 'Bermuda' },
  { code: 'BT', region: 'Asia', country: 'Bhutan' },
  { code: 'BO', region: 'Latin America and the Caribbean', country: 'Bolivia' },
  { code: 'BA', region: 'Europe', country: 'Bosnia and Herzegovina' },
  { code: 'BW', region: 'Africa', country: 'Botswana' },
  { code: 'BR', region: 'Latin America and the Caribbean', country: 'Brazil' },
  { code: 'BN', region: 'Asia', country: 'Brunei' },
  { code: 'BG', region: 'Europe', country: 'Bulgaria' },
  { code: 'BF', region: 'Africa', country: 'Burkina Faso' },
  { code: 'BI', region: 'Africa', country: 'Burundi' },
  { code: 'CI', region: 'Africa', country: "Côte d'Ivoire" },
  { code: 'CV', region: 'Africa', country: 'Cabo Verde' },
  { code: 'KH', region: 'Asia', country: 'Cambodia' },
  { code: 'CM', region: 'Africa', country: 'Cameroon' },
  { code: 'CA', region: 'North America', country: 'Canada' },
  { code: 'CF', region: 'Africa', country: 'Central African Republic' },
  { code: 'TD', region: 'Africa', country: 'Chad' },
  { code: 'CL', region: 'Latin America and the Caribbean', country: 'Chile' },
  { code: 'CN', region: 'Asia', country: 'China' },
  { code: 'CO', region: 'Latin America and the Caribbean', country: 'Colombia' },
  { code: 'KM', region: 'Africa', country: 'Comoros' },
  { code: 'CG', region: 'Africa', country: 'Congo' },
  { code: 'CR', region: 'Latin America and the Caribbean', country: 'Costa Rica' },
  { code: 'HR', region: 'Europe', country: 'Croatia' },
  { code: 'CU', region: 'Latin America and the Caribbean', country: 'Cuba' },
  { code: 'CY', region: 'Europe', country: 'Cyprus' },
  { code: 'CZ', region: 'Europe', country: 'Czech Republic' },
  { code: 'CD', region: 'Africa', country: 'Democratic Republic of the Congo' },
  { code: 'DK', region: 'Europe', country: 'Denmark' },
  { code: 'DJ', region: 'Africa', country: 'Djibouti' },
  { code: 'DM', region: 'Latin America and the Caribbean', country: 'Dominica' },
  { code: 'DO', region: 'Latin America and the Caribbean', country: 'Dominican Republic' },
  { code: 'EC', region: 'Latin America and the Caribbean', country: 'Ecuador' },
  { code: 'EG', region: 'Africa', country: 'Egypt' },
  { code: 'SV', region: 'Latin America and the Caribbean', country: 'El Salvador' },
  { code: 'GQ', region: 'Africa', country: 'Equatorial Guinea' },
  { code: 'ER', region: 'Africa', country: 'Eritrea' },
  { code: 'EE', region: 'Europe', country: 'Estonia' },
  { code: 'SZ', region: 'Africa', country: 'Eswatini' },
  { code: 'ET', region: 'Africa', country: 'Ethiopia' },
  { code: 'FJ', region: 'Oceania', country: 'Fiji' },
  { code: 'FI', region: 'Europe', country: 'Finland' },
  { code: 'FR', region: 'Europe', country: 'France' },
  { code: 'GA', region: 'Africa', country: 'Gabon' },
  { code: 'GM', region: 'Africa', country: 'Gambia' },
  { code: 'GE', region: 'Asia', country: 'Georgia' },
  { code: 'DE', region: 'Europe', country: 'Germany' },
  { code: 'GH', region: 'Africa', country: 'Ghana' },
  { code: 'GR', region: 'Europe', country: 'Greece' },
  { code: 'GD', region: 'Latin America and the Caribbean', country: 'Grenada' },
  { code: 'GT', region: 'Latin America and the Caribbean', country: 'Guatemala' },
  { code: 'GN', region: 'Africa', country: 'Guinea' },
  { code: 'GW', region: 'Africa', country: 'Guinea-Bissau' },
  { code: 'GY', region: 'Latin America and the Caribbean', country: 'Guyana' },
  { code: 'HT', region: 'Latin America and the Caribbean', country: 'Haiti' },
  { code: 'VA', region: 'Europe', country: 'Holy See' },
  { code: 'HN', region: 'Latin America and the Caribbean', country: 'Honduras' },
  { code: 'HU', region: 'Europe', country: 'Hungary' },
  { code: 'HK', region: 'Asia', country: 'Hong Kong' },
  { code: 'IS', region: 'Europe', country: 'Iceland' },
  { code: 'IN', region: 'Asia', country: 'India' },
  { code: 'ID', region: 'Asia', country: 'Indonesia' },
  { code: 'IR', region: 'Asia', country: 'Iran' },
  { code: 'IQ', region: 'Asia', country: 'Iraq' },
  { code: 'IE', region: 'Europe', country: 'Ireland' },
  { code: 'IL', region: 'Asia', country: 'Israel' },
  { code: 'IT', region: 'Europe', country: 'Italy' },
  { code: 'JM', region: 'Latin America and the Caribbean', country: 'Jamaica' },
  { code: 'JP', region: 'Asia', country: 'Japan' },
  { code: 'JO', region: 'Asia', country: 'Jordan' },
  { code: 'KZ', region: 'Asia', country: 'Kazakhstan' },
  { code: 'KE', region: 'Africa', country: 'Kenya' },
  { code: 'KI', region: 'Oceania', country: 'Kiribati' },
  { code: 'KW', region: 'Asia', country: 'Kuwait' },
  { code: 'KG', region: 'Asia', country: 'Kyrgyzstan' },
  { code: 'LA', region: 'Asia', country: 'Laos' },
  { code: 'LV', region: 'Europe', country: 'Latvia' },
  { code: 'LB', region: 'Asia', country: 'Lebanon' },
  { code: 'LS', region: 'Africa', country: 'Lesotho' },
  { code: 'LR', region: 'Africa', country: 'Liberia' },
  { code: 'LY', region: 'Africa', country: 'Libya' },
  { code: 'LI', region: 'Europe', country: 'Liechtenstein' },
  { code: 'LT', region: 'Europe', country: 'Lithuania' },
  { code: 'LU', region: 'Europe', country: 'Luxembourg' },
  { code: 'MK', region: 'Europe', country: 'Macedonia' },
  { code: 'MG', region: 'Africa', country: 'Madagascar' },
  { code: 'MW', region: 'Africa', country: 'Malawi' },
  { code: 'MY', region: 'Asia', country: 'Malaysia' },
  { code: 'MV', region: 'Asia', country: 'Maldives' },
  { code: 'ML', region: 'Africa', country: 'Mali' },
  { code: 'MT', region: 'Europe', country: 'Malta' },
  { code: 'MH', region: 'Oceania', country: 'Marshall Islands' },
  { code: 'MR', region: 'Africa', country: 'Mauritania' },
  { code: 'MU', region: 'Africa', country: 'Mauritius' },
  { code: 'MX', region: 'Latin America and the Caribbean', country: 'Mexico' },
  { code: 'FM', region: 'Oceania', country: 'Micronesia' },
  { code: 'MD', region: 'Europe', country: 'Moldova' },
  { code: 'MC', region: 'Europe', country: 'Monaco' },
  { code: 'MN', region: 'Asia', country: 'Mongolia' },
  { code: 'ME', region: 'Europe', country: 'Montenegro' },
  { code: 'MA', region: 'Africa', country: 'Morocco' },
  { code: 'MZ', region: 'Africa', country: 'Mozambique' },
  { code: 'MM', region: 'Asia', country: 'Myanmar' },
  { code: 'NA', region: 'Africa', country: 'Namibia' },
  { code: 'NR', region: 'Oceania', country: 'Nauru' },
  { code: 'NP', region: 'Asia', country: 'Nepal' },
  { code: 'NL', region: 'Europe', country: 'Netherlands' },
  { code: 'NZ', region: 'Oceania', country: 'New Zealand' },
  { code: 'NI', region: 'Latin America and the Caribbean', country: 'Nicaragua' },
  { code: 'NE', region: 'Africa', country: 'Niger' },
  { code: 'NG', region: 'Africa', country: 'Nigeria' },
  { code: 'NU', region: 'Oceania', country: 'Niue' },
  { code: 'KP', region: 'Asia', country: 'North Korea' },
  { code: 'NO', region: 'Europe', country: 'Norway' },
  { code: 'OM', region: 'Asia', country: 'Oman' },
  { code: 'PK', region: 'Asia', country: 'Pakistan' },
  { code: 'PW', region: 'Oceania', country: 'Palau' },
  { code: 'PA', region: 'Latin America and the Caribbean', country: 'Panama' },
  { code: 'PG', region: 'Oceania', country: 'Papua New Guinea' },
  { code: 'PY', region: 'Latin America and the Caribbean', country: 'Paraguay' },
  { code: 'PE', region: 'Latin America and the Caribbean', country: 'Peru' },
  { code: 'PH', region: 'Asia', country: 'Philippines' },
  { code: 'PL', region: 'Europe', country: 'Poland' },
  { code: 'PT', region: 'Europe', country: 'Portugal' },
  { code: 'QA', region: 'Asia', country: 'Qatar' },
  { code: 'RO', region: 'Europe', country: 'Romania' },
  { code: 'RU', region: 'Asia', country: 'Russia' },
  { code: 'RW', region: 'Africa', country: 'Rwanda' },
  { code: 'KN', region: 'Latin America and the Caribbean', country: 'Saint Kitts and Nevis' },
  { code: 'LC', region: 'Latin America and the Caribbean', country: 'Saint Lucia' },
  { code: 'VC', region: 'Latin America and the Caribbean', country: 'Saint Vincent and the Grenadines' },
  { code: 'WS', region: 'Oceania', country: 'Samoa' },
  { code: 'SM', region: 'Europe', country: 'San Marino' },
  { code: 'ST', region: 'Africa', country: 'Sao Tome and Principe' },
  { code: 'SA', region: 'Asia', country: 'Saudi Arabia' },
  { code: 'SN', region: 'Africa', country: 'Senegal' },
  { code: 'RS', region: 'Europe', country: 'Serbia' },
  { code: 'SC', region: 'Africa', country: 'Seychelles' },
  { code: 'SL', region: 'Africa', country: 'Sierra Leone' },
  { code: 'SG', region: 'Asia', country: 'Singapore' },
  { code: 'SK', region: 'Europe', country: 'Slovakia' },
  { code: 'SI', region: 'Europe', country: 'Slovenia' },
  { code: 'SB', region: 'Oceania', country: 'Solomon Islands' },
  { code: 'SO', region: 'Africa', country: 'Somalia' },
  { code: 'ZA', region: 'Africa', country: 'South Africa' },
  { code: 'KR', region: 'Asia', country: 'South Korea' },
  { code: 'SS', region: 'Africa', country: 'South Sudan' },
  { code: 'ES', region: 'Europe', country: 'Spain' },
  { code: 'LK', region: 'Asia', country: 'Sri Lanka' },
  { code: 'SD', region: 'Africa', country: 'Sudan' },
  { code: 'SR', region: 'Latin America and the Caribbean', country: 'Suriname' },
  { code: 'SE', region: 'Europe', country: 'Sweden' },
  { code: 'CH', region: 'Europe', country: 'Switzerland' },
  { code: 'SY', region: 'Asia', country: 'Syria' },
  { code: 'TW', region: 'Asia', country: 'Taiwan' },
  { code: 'TJ', region: 'Asia', country: 'Tajikistan' },
  { code: 'TZ', region: 'Africa', country: 'Tanzania' },
  { code: 'TH', region: 'Asia', country: 'Thailand' },
  { code: 'TL', region: 'Asia', country: 'Timor-Leste' },
  { code: 'TG', region: 'Africa', country: 'Togo' },
  { code: 'TO', region: 'Oceania', country: 'Tonga' },
  { code: 'TT', region: 'Latin America and the Caribbean', country: 'Trinidad and Tobago' },
  { code: 'TN', region: 'Africa', country: 'Tunisia' },
  { code: 'TR', region: 'Asia', country: 'Turkey' },
  { code: 'TM', region: 'Asia', country: 'Turkmenistan' },
  { code: 'TV', region: 'Oceania', country: 'Tuvalu' },
  { code: 'UG', region: 'Africa', country: 'Uganda' },
  { code: 'UA', region: 'Europe', country: 'Ukraine' },
  { code: 'AE', region: 'Asia', country: 'United Arab Emirates' },
  { code: 'GB', region: 'Europe', country: 'United Kingdom' },
  { code: 'US', region: 'North America', country: 'United States' },
  { code: 'UY', region: 'Latin America and the Caribbean', country: 'Uruguay' },
  { code: 'UZ', region: 'Asia', country: 'Uzbekistan' },
  { code: 'VU', region: 'Oceania', country: 'Vanuatu' },
  { code: 'VE', region: 'Latin America and the Caribbean', country: 'Venezuela' },
  { code: 'VN', region: 'Asia', country: 'Vietnam' },
  { code: 'YE', region: 'Asia', country: 'Yemen' },
  { code: 'ZM', region: 'Africa', country: 'Zambia' },
  { code: 'ZW', region: 'Africa', country: 'Zimbabwe' }
];

export const COUNTRY_NAME_ALIASES = {
  'Iran, Islamic Republic of': 'IR',
  'United States of America': 'US'
};

const COUNTRY_BY_NAME = new Map(COUNTRY_LIST.map(country => [country.country, country]));
const COUNTRY_BY_CODE = new Map(COUNTRY_LIST.map(country => [country.code, country]));

export const getCountryByName = name => COUNTRY_BY_NAME.get(name);

export const getCountryByCode = code => COUNTRY_BY_CODE.get(code);
